import type Joi from 'joi';

const validate = <T>(object: T, schema: Joi.ObjectSchema<T>) => {
  const result = schema.validate(object, {presence: 'required'});

  return result;
};

export default validate;
